var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"role",rawName:"v-role",value:('est'),expression:"'est'"}],staticClass:"formPosition"},[[_c('v-container',{staticClass:"grey lighten-5"},[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v(" Processando ...")]),_c('br')])])],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }